
<div class="custom-dialog" >
<!-- {{data | json}} -->

<div class="modal-green-icon modal-icon">
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23 0.5C35.4263 0.5 45.5 10.5736 45.5 23C45.5 35.4263 35.4263 45.5 23 45.5C10.5736 45.5 0.5 35.4263 0.5 23C0.5 10.5736 10.5736 0.5 23 0.5ZM30.2443 16.1818L20.1875 26.2384L15.7557 21.8068C15.0967 21.1478 14.0283 21.1478 13.3693 21.8068C12.7103 22.4658 12.7103 23.5342 13.3693 24.1932L18.9943 29.8182C19.6533 30.4772 20.7217 30.4772 21.3807 29.8182L32.6307 18.5682C33.2897 17.9092 33.2897 16.8408 32.6307 16.1818C31.9717 15.5228 30.9033 15.5228 30.2443 16.1818Z" fill="white"/>
      </svg>
  </div>


  <div class="modal-title">

    {{ data?.message && data.message.trim() !== '' ? data.message : 'Application Approved Successfully' }}
  
  </div>
  <!-- <div class="modal-text">You can view form under submitted approvals</div> -->
  <div class="text-center">
    <button class="btn btn-success" (click)="approve()">DONE</button>
  </div>

      
</div>